"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.shouldFilter = shouldFilter;
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _get = _interopRequireDefault(require("transmute/get"));

var _TimelineFiltersStore = _interopRequireDefault(require("crm_ui/timeline/data/stores/TimelineFiltersStore"));

var _TimelineFavoriteEventsOverrideStore = _interopRequireDefault(require("crm_ui/timeline/data/stores/TimelineFavoriteEventsOverrideStore"));

var _TimelineMonthsStore = _interopRequireDefault(require("crm_ui/timeline/data/stores/TimelineMonthsStore"));

var _TimelineStatusStore = _interopRequireDefault(require("crm_ui/timeline/data/stores/TimelineStatusStore"));

var _PinnedEngagementsStore = _interopRequireDefault(require("crm_ui/pinnedEngagements/stores/PinnedEngagementsStore"));

var _immutable = require("immutable");

var _memoize = _interopRequireDefault(require("transmute/memoize"));

var _partial = _interopRequireDefault(require("transmute/partial"));

var _I18n = _interopRequireDefault(require("I18n"));

var _ETypeToFilterNameMap = _interopRequireDefault(require("crm_ui/timeline/helpers/ETypeToFilterNameMap"));

var _TimelineConstants = require("crm_universal/timeline/TimelineConstants");

var _ETypes = _interopRequireWildcard(require("crm_universal/timeline/ETypes"));

var _TimelineEventsStore = _interopRequireDefault(require("../stores/TimelineEventsStore"));

var _EngagementsStore = _interopRequireDefault(require("crm_data/engagements/EngagementsStore"));

var _identity = _interopRequireDefault(require("transmute/identity"));

var _timelineItemComparator = require("crm_ui/timeline/helpers/timelineItemComparator");

var _ImmutableModel = require("customer-data-objects/model/ImmutableModel");

var _ScopesContainer = _interopRequireDefault(require("crm_internal/containers/ScopesContainer"));

function getId(event) {
  return event.get('id');
}

function getMonthsPassed(fromMonth, toMonth) {
  return Math.max(Math.ceil(_I18n.default.moment.duration(toMonth - fromMonth).asMonths()), 1);
}

function getMonthTimestampFromToNow(now, monthsToGoBack) {
  return _I18n.default.moment.userTz(now).subtract(monthsToGoBack, 'month').endOf('month').valueOf();
}

function hasEvents(month) {
  return month && month.size > 0;
}

function isMonthEmpty(currentMonthTimestamp, monthsStore) {
  var currentMonthEvents = monthsStore.get(currentMonthTimestamp);
  return !hasEvents(currentMonthEvents);
}

function isOptOutOrUnbounce(eventType) {
  return eventType === _ETypes.eventEmailOptOut || eventType === _ETypes.eventEmailUnbounce;
}

function sharesTeamId(selectedFilters, timelineItem) {
  var createdBy = timelineItem.get('teamId');
  var selectedTeams = selectedFilters.get('selectedTeams');
  var hasSelectedTeam = selectedFilters.get('selectedTeams') && selectedFilters.get('selectedTeams').size;

  if (!hasSelectedTeam) {
    return true;
  }

  return hasSelectedTeam && selectedTeams.includes(createdBy);
}

function sharesUserId(selectedFilters, timelineItem) {
  var createdBy = timelineItem.get('createdBy');
  var selectedUsers = selectedFilters.get('selectedUsers');
  var hasSelectedUsers = selectedUsers && selectedUsers.size;

  if (!hasSelectedUsers) {
    return true;
  }

  return hasSelectedUsers && selectedUsers.includes(createdBy);
}

function sharesSearchText(selectedFilters, timelineItem) {
  var searchTextFilter = selectedFilters.get('searchText');
  var timelineText = timelineItem.get('searchText');

  if (!searchTextFilter) {
    return true;
  }

  return searchTextFilter === timelineText;
}

function shouldFilter(objectType, allFilters, pinnedEngagementId, timelineItem) {
  var eventType = timelineItem.get('eventType');
  var filterToCheck = timelineItem.get('integrationAppId') || _TimelineConstants.FAVORITE_ENGAGEMENT_TYPES.get(eventType) || (0, _ETypeToFilterNameMap.default)(objectType, eventType);
  var isTimelineItemPinned = "" + pinnedEngagementId === timelineItem.get('id');
  var hasSelectedTeam = sharesTeamId(allFilters, timelineItem);
  var hasSelectedUser = sharesUserId(allFilters, timelineItem);
  var hasSearchText = sharesSearchText(allFilters, timelineItem);
  var isMarketingStarterOrFree = _ScopesContainer.default.someScoped(['marketing-free-product', 'marketing-starter-product']) && !_ScopesContainer.default.getContainer().get()['marketing-product']; // analytics events aren't available for marketing free/starter users but cookie banners, which
  // are under the analytics filter, are available so allow them
  // can be removed after https://git.hubteam.com/HubSpot/CRM-Issues/issues/4020 is resolved

  var shouldFilterAnalyticsEvent = !(filterToCheck === (0, _ETypeToFilterNameMap.default)(objectType, _ETypes.default.eventAnalytics) && eventType !== 'eventPrivacyConsent' && isMarketingStarterOrFree);
  return !isTimelineItemPinned && hasSelectedUser && hasSelectedTeam && hasSearchText && shouldFilterAnalyticsEvent && (allFilters.get('eventTypes').includes(filterToCheck) || allFilters.get('eventTypes').includes('EMAIL_SENDS') && isOptOutOrUnbounce(eventType));
}

function getMonthLabel(timestamp) {
  var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'MMMM YYYY';

  if (timestamp._isAMomentObject) {
    return timestamp.format(format);
  }

  return _I18n.default.moment.userTz(Number(timestamp)).format(format);
}

function getMonthLabels(timestamp) {
  var label = getMonthLabel(timestamp);
  return (0, _immutable.Map)({
    label: label,
    text: _I18n.default.text('profileContentTimeline.timelineMonthEvent.emptyMonth', {
      month: label
    })
  });
}

function getCollapsedMonthsLabels(monthInfo) {
  var timestampList = monthInfo.keySeq().map(function (timestamp) {
    return Number(timestamp);
  }).sort().reverse();

  var recentMonth = _I18n.default.moment.userTz(timestampList.first());

  var oldestMonth = _I18n.default.moment.userTz(timestampList.last());

  var oldestMonthWithoutYear = getMonthLabel(oldestMonth, 'MMMM');
  var oldestMonthWithYear = getMonthLabel(oldestMonth);
  var recentMonthWithoutYear = getMonthLabel(recentMonth, 'MMMM');
  var recentMonthWithYear = getMonthLabel(recentMonth);

  if (recentMonth.year() === oldestMonth.year()) {
    return (0, _immutable.Map)({
      label: recentMonthWithoutYear + " - " + oldestMonthWithYear,
      text: _I18n.default.text('profileContentTimeline.timelineMonthEvent.collapsedMonths', {
        start: oldestMonthWithoutYear,
        end: recentMonthWithYear
      })
    });
  }

  return (0, _immutable.Map)({
    label: recentMonthWithYear + " - " + oldestMonthWithYear,
    text: _I18n.default.text('profileContentTimeline.timelineMonthEvent.collapsedMonths', {
      start: oldestMonthWithYear,
      end: recentMonthWithYear
    })
  });
}

function getMonthLabelAndEvents(monthInfo) {
  var events = monthInfo.first();

  if (monthInfo.size > 1) {
    var labels = getCollapsedMonthsLabels(monthInfo);
    return (0, _immutable.Map)({
      events: events,
      label: labels.get('label'),
      text: labels.get('text')
    });
  }

  if (events.size === 0) {
    var _labels = getMonthLabels(monthInfo.keySeq().first());

    return (0, _immutable.Map)({
      events: events,
      label: _labels.get('label'),
      text: _labels.get('text')
    });
  }

  var label = getMonthLabel(monthInfo.keySeq().first());
  return (0, _immutable.Map)({
    events: events,
    label: label
  });
}

function getMonthsToRender(monthsList, filteredMonthsStore) {
  return monthsList.reduce(function (list, currentMonthTimestamp) {
    if (isMonthEmpty(currentMonthTimestamp, filteredMonthsStore)) {
      return list;
    } else {
      var monthInfo = (0, _immutable.Map)((0, _defineProperty2.default)({}, currentMonthTimestamp, filteredMonthsStore.get(currentMonthTimestamp)));
      list = list.push(monthInfo);
    }

    return list;
  }, (0, _immutable.List)()).map(getMonthLabelAndEvents);
}

function getTrimmedMonthsToRender(monthsToRender) {
  if (monthsToRender.last().get('events').size === 0) {
    return monthsToRender.delete(-1);
  }

  return monthsToRender;
}

function getFilteredMonthsStore(allFilters, monthsStore, monthsList, objectType, pinnedEngagementId) {
  var _shouldFilter = (0, _partial.default)(shouldFilter, objectType, allFilters, pinnedEngagementId);

  return monthsList.reduce(function (map, monthTimestamp) {
    var allEvents = monthsStore.get(monthTimestamp) || (0, _immutable.Set)();
    var eventsToRender = allEvents.filter(_shouldFilter).map(getId);
    return map.set(monthTimestamp, eventsToRender);
  }, (0, _immutable.Map)());
}

var getMonthsList = (0, _memoize.default)(function (fromDate, now) {
  var fromMonth = _I18n.default.moment(fromDate).startOf('month').valueOf();

  var toMonth = _I18n.default.moment(now).endOf('month').valueOf();

  var monthsPassed = getMonthsPassed(fromMonth, toMonth);
  var monthsList = [];
  var monthsProcessed = 0;

  while (monthsProcessed < monthsPassed) {
    var monthTimestamp = "" + getMonthTimestampFromToNow(now, monthsProcessed);

    if (fromDate <= monthTimestamp && monthTimestamp <= toMonth) {
      monthsList.push(monthTimestamp);
    }

    monthsProcessed += 1;
  }

  return monthsList;
});

function shouldFilterFuture(objectType, allFilters, timelineItem) {
  var eventType = timelineItem.get('eventType');
  var hasSelectedTeam = sharesTeamId(allFilters, timelineItem);
  var hasSelectedUser = sharesUserId(allFilters, timelineItem);
  var hasSearchText = sharesSearchText(allFilters, timelineItem);
  var filterToCheck = _TimelineConstants.FAVORITE_ENGAGEMENT_TYPES.get(eventType) || (0, _ETypeToFilterNameMap.default)(objectType, eventType);
  return hasSelectedTeam && hasSelectedUser && hasSearchText && allFilters.get('eventTypes').includes(filterToCheck);
}

function getFilteredFutureTimelineEvents(allFilters, futureEvents, objectType) {
  var _shouldFilter = (0, _partial.default)(shouldFilterFuture, objectType, allFilters);

  return futureEvents.filter(_shouldFilter).map(getId);
}

var hydrateEventsForIds = function hydrateEventsForIds(ids) {
  return ids.map(function (id) {
    return _TimelineEventsStore.default.get(id);
  }).filter(_identity.default).sort(_timelineItemComparator.timelineItemComparator).toList();
};

var TimelineEventsDependency = {
  stores: [_TimelineFiltersStore.default, _TimelineMonthsStore.default, _TimelineStatusStore.default, _PinnedEngagementsStore.default, _TimelineFavoriteEventsOverrideStore.default, _TimelineEventsStore.default, _EngagementsStore.default],
  deref: function deref(_ref) {
    var objectType = _ref.objectType,
        subjectId = _ref.subjectId,
        subject = _ref.subject;

    if (subject && !(objectType || subjectId)) {
      objectType = (0, _ImmutableModel.getObjectType)(subject);
      subjectId = String((0, _ImmutableModel.getId)(subject));
    }

    var favoriteEventsOverride = (0, _get.default)('eventTypes', _TimelineFavoriteEventsOverrideStore.default.get(objectType));

    var eventTypeFilters = favoriteEventsOverride || _TimelineFiltersStore.default.get(objectType) && _TimelineFiltersStore.default.get(objectType).get('eventTypes');

    var allFilters = _TimelineFavoriteEventsOverrideStore.default.get(objectType) || _TimelineFiltersStore.default.get(objectType);

    if (!eventTypeFilters) {
      return (0, _immutable.List)();
    }

    var fromDate;

    var now = _TimelineStatusStore.default.get('now');

    var firstDateRange = _TimelineStatusStore.default.get('firstDateRange');

    var timelineStatus = _TimelineStatusStore.default.get('timelineStatus');

    if (timelineStatus.getIn(['originalPayload', 'fromDate'])) {
      fromDate = timelineStatus.getIn(['originalPayload', 'fromDate']);
    } else {
      fromDate = firstDateRange.get('fromDate');
    }

    if (!fromDate || !now) {
      return (0, _immutable.List)();
    }

    var monthsList = getMonthsList(fromDate, now);

    var pinnedEngagementId = _PinnedEngagementsStore.default.get((0, _immutable.Map)({
      objectType: objectType,
      subjectId: subjectId
    }));

    var filteredMonthsStore = getFilteredMonthsStore(allFilters, _TimelineMonthsStore.default, monthsList, objectType, pinnedEngagementId);
    var monthsToRender = getMonthsToRender(monthsList, filteredMonthsStore);

    if (monthsToRender.size && favoriteEventsOverride && !timelineStatus.get('hasMore')) {
      monthsToRender = getTrimmedMonthsToRender(monthsToRender);
    }

    var pastEvents = monthsToRender.reduceRight(function (acc, month) {
      return (0, _immutable.List)([(0, _immutable.Map)({
        label: month.get('label'),
        text: month.get('text', ''),
        count: month.get('events').size
      })]).concat(hydrateEventsForIds(month.get('events'))).concat(acc);
    }, (0, _immutable.List)());

    var futureEvents = _TimelineMonthsStore.default.get('FUTURE');

    if (!allFilters || !futureEvents || !futureEvents.size) {
      return pastEvents;
    } else {
      var filteredFutureEvents = getFilteredFutureTimelineEvents(allFilters, futureEvents, objectType);

      if (!filteredFutureEvents.size) {
        return pastEvents;
      }

      return (0, _immutable.List)([(0, _immutable.Map)({
        label: _I18n.default.text('profileContentTimeline.upcomingEvents'),
        isFuture: true
      })]).concat(hydrateEventsForIds(filteredFutureEvents).map(function (item) {
        return item.set('isFuture', true);
      })).concat(pastEvents);
    }
  }
};
var _default = TimelineEventsDependency;
exports.default = _default;